import PrivacyPolicy from '~/components/Terms/PrivacyPolicy/PrivacyPolicy';
import { HelmetHead } from '~/components/common';

export default function Privacy() {
  return (
    <>
      <HelmetHead title='Company' />
      <PrivacyPolicy />
    </>
  );
}
